import axios from 'axios';

// Configuración base de axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3900',
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_API_KEY
  }
});

// Interceptor para logging (opcional)
api.interceptors.request.use(
  (config) => {
    // Verificar que el API Key esté configurado
    if (!process.env.REACT_APP_API_KEY) {
      console.warn('[API] ADVERTENCIA: No se encontró REACT_APP_API_KEY en las variables de entorno');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.error('[API] Error de autenticación:', error.response.data?.message);
      // Aquí podrías redirigir a una página de error o mostrar un mensaje
    }
    return Promise.reject(error);
  }
);

export default api;
